import Cookies from "js-cookie";

const TokenKey = "Admin-Token";

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  // 设置 1小时过期 (1/24天)
  return Cookies.set(TokenKey, token, { expires: 1 / 24 });
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}
